import React from "react";
import { render } from "react-dom";
import App from "../components/Fastrack/App";

document.addEventListener("DOMContentLoaded", () => {
  render(<App />, document.getElementById("fastrack-root"));
});
